var exports = {
  "k": "x9245d464--b8733d--container",
};

module.exports = exports;
